// What a lump-sum advance was given for. Keep in sync with ADVANCE_KINDS in
// erpapi/routes/employees.js — the API rejects anything else and falls back to
// 'personal'. Purpose only: it never changes how the advance is recovered.
export const ADVANCE_KINDS = [
  ['personal', 'Personal'],
  ['festival', 'Festival'],
  ['medical', 'Medical'],
  ['education', 'Education'],
  ['travel', 'Travel'],
  ['emergency', 'Emergency'],
  ['other', 'Other'],
];

export const advanceKind = (k) => (ADVANCE_KINDS.find(([v]) => v === k) || [null, null])[1] || 'Personal';
